import * as React from "react"
import { Box, Chip, IconButton, Modal, Typography } from "@mui/material"
import { ImageSeeker, IconSeeker } from "@ui-seeker/core"

import { imageModal } from "./@signals"


export default function ImageModal() {
    const data = imageModal.value
    const isOpen = data !== null

    const handleClose = () => {
        imageModal.value = null
    }

    return (
        <Modal
            open={isOpen}
            onClose={handleClose}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 2
            }}
        >
            <Box
                sx={{
                    width: '90vw',
                    maxWidth: 700,
                    maxHeight: '90vh',
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 24,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden'
                }}
            >
                {/* Header */}
                <Box sx={{
                    p: 2,
                    borderBottom: '1px solid #e5e7eb',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    gap: 2
                }}>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography variant="h6" sx={{ fontWeight: 600, wordBreak: 'break-word' }}>
                            {data?.title || 'Product Image'}
                        </Typography>
                        {data?.variantRaw && (
                            <Chip
                                label={data.variantRaw}
                                size="small"
                                sx={{
                                    mt: 1,
                                    fontSize: '0.8rem',
                                    fontWeight: 600,
                                    backgroundColor: '#e0e7ff',
                                    color: '#4338ca'
                                }}
                            />
                        )}
                    </Box>
                    <IconButton onClick={handleClose} sx={{ flexShrink: 0 }}>
                        <IconSeeker icon="xmark" />
                    </IconButton>
                </Box>

                {/* Image */}
                <Box sx={{
                    flex: 1,
                    p: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    bgcolor: '#f9fafb',
                    minHeight: 400
                }}>
                    {data?.image ? (
                        <ImageSeeker
                            useSpinner
                            lazyLoad={false}
                            src={data.image}
                            sx={{
                                maxWidth: '100%',
                                maxHeight: '60vh',
                                objectFit: 'contain'
                            }}
                        />
                    ) : (
                        <Box sx={{ color: '#9ca3af', textAlign: 'center' }}>
                            <IconSeeker icon="image" sx={{ fontSize: 64, mb: 1 }} />
                            <Typography variant="body1">No image available</Typography>
                        </Box>
                    )}
                </Box>
            </Box>
        </Modal>
    )
}
